import { getStore } from "../stores/base.js";
import { LISTENER_CMDS } from "./constants.js";

export function processHandler(data, workerInstance) {
  switch (data.command) {
    case LISTENER_CMDS.PROCESS_OPEN_FORM:
      return openForm(data, workerInstance.pageId);
    default:
      return false;
  }
}

async function openForm(data, pageId) {
  const usePageRuntimeStore = getStore(`runtime_page_${pageId}`);
  if (usePageRuntimeStore) {
    usePageRuntimeStore.getState().renderPortal({
      id: `${data.flowId}/openform`,
      path: `process/openform`,
      componentProps: {
        ...data,
        onDone: () => {},
        onCancel: () => {}
      }
    });
    return;
  }
}
